"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _global = _interopRequireDefault(require("global"));
var _reactRecaptchaGoogle = require("react-recaptcha-google");
var Experiment = function Experiment(_ref) {
  var children = _ref.children,
    experimentId = _ref.experimentId,
    loadCaptcha = _ref.loadCaptcha;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    variant = _useState4[0],
    setVariant = _useState4[1];
  (0, _react.useEffect)(function () {
    if (typeof _global["default"].grecaptcha === 'undefined') {
      (0, _reactRecaptchaGoogle.loadReCaptcha)();
    }
    if (_global["default"].dataLayer) {
      _global["default"].dataLayer.push({
        event: 'optimize.activate'
      });
    }
    if (_global["default"].gtag) {
      _global["default"].gtag('event', 'optimize.callback', {
        name: experimentId,
        callback: function callback(value) {
          setVariant(+value);
          setLoading(false);
        }
      });
    }
  }, []);
  if (loading) {
    // safety net if gtag fails so it will render original anyway
    setTimeout(function () {
      return loading && setLoading(false);
    }, 3000);
    return null;
  }
  return children({
    variant: variant
  });
};
Experiment.propTypes = {
  children: _propTypes["default"].any.isRequired,
  experimentId: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Experiment;